import React, { useState, useContext } from "react";
import { AuthContext } from "../context/AuthContext";
import { Navigate } from "react-router-dom";
import "../styles/Login.css";

const Login = () => {
  const { user, login } = useContext(AuthContext);
  const [formData, setFormData] = useState({ email: "", password: "" });
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false); // 👈 Adăugăm un loading state

  // 🔹 Dacă utilizatorul este deja autentificat, redirecționează-l la dashboard
  if (user) {
    return <Navigate to="/dashboard" />;
  }

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value.trim() });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null); // Resetare erori
    setLoading(true); // Activare loading

    if (!formData.email || !formData.password) {
      setLoading(false);
      setError("⚠️ Email și parolă sunt obligatorii!");
      return;
    }

    try {
      const response = await login(formData.email, formData.password);

      if (response?.error) {
        console.error("❌ Eroare la autentificare:", response.error);
        setError(response.error);
        setLoading(false);
        return;
      }

      console.log("✅ Autentificare reușită:", response);
    } catch (error) {
      console.error("❌ Eroare la autentificare:", error);
      setError("Eroare la autentificare. Verifică conexiunea și încearcă din nou.");
    } finally {
      setLoading(false); // Dezactivăm loading
    }
  };

  return (
    <div className="login-container">
      <div className="login-card">
        <img src="/images/Logo.webp" alt="Logo" className="login-logo" />
        <h2>Autentificare</h2>
        {error && <p className="error-message">{error}</p>}
        <form onSubmit={handleSubmit}>
          <div className="input-group">
            <label>Email:</label>
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
              disabled={loading}
            />
          </div>
          <div className="input-group">
            <label>Parolă:</label>
            <input
              type="password"
              name="password"
              value={formData.password}
              onChange={handleChange}
              required
              disabled={loading}
            />
          </div>
          <button type="submit" className="login-button" disabled={loading}>
            {loading ? "Se autentifică..." : "Login"}
          </button>
        </form>
      </div>
    </div>
  );  
};

export default Login;